<template>
  <Header/>
  <div class="img-container" style="margin: 40px 0;">
    <img alt="" class="img-container" src="../assets/images/201910260927085114.jpeg"/>
  </div>
  <div class="p_container mauto clearfix">
    <div class="p_left">
      <div class="sidebar" editok="online">
        <div class="sortnavt"><h3>新闻分类</h3></div>
        <ul class="sortnavul">
          <li class="sortnavli" v-for="(item, index) in navList" :key="index">
            <a :href="item.path" target="" class="sortnava">{{ item.label }}</a>
          </li>
        </ul>
      </div>
      <div class="clear">
      </div>
    </div>
    <div class="p_right" style="margin-left: 30px;">
      <div class="p_right1">
        <div class="title01" editok="online">
          <ins class="ticon08"></ins>
          <h3>{{ domTitle }}</h3>
        </div>
        <div class="p_about">
          <div id="com_thenm_list" editok="online" class="content">
            <h1 class="p_n_title">{{ detail.post_title }}</h1>
            <div v-if="detail.post_date" class="p_n_info">
              发布时间：{{ detail.post_date.split(' ')[0] }}
            </div>
            <div class="remark">
              <div id="con" class="con">
                <div id="Div1" class="con">
                  <div id="right_con">
                    <div v-html="detail.post_content">

                    </div>
                    <h4 class="related">
                      <span>相关文章</span>
                    </h4>
                    <div class="relatedlist">
                      <ul class="list-none metlist" style="padding-left: 0px;">

                        <div v-for="(item, index) in related" :key="index">
                          <li v-if="index <= 5" class="list11 top span-title">
                            <a :href="'/#/detail?id=' + item.ID" :title="item.post_title" target="_blank">
                              {{ item.post_title }}
                            </a>
                          </li>
                        </div>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="prevnext">
              <span class="prevrecord">
                上一条:
                <a v-if="left" :href="'/#/detail?id=' + left.ID" :title="left.post_title">
                  {{ left.post_title }}
                </a>
              </span>

              <span class="nextrecord">
                下一条:
                <a v-if="right" :href="'/#/detail?id=' + right.ID" :title="right.post_title">
                  {{ right.post_title }}
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import http from "@/util/http"

export default {
  name: "DetailPage",
  components: {Footer, Header},
  data() {
    return {
      domTitle: undefined,
      right: undefined,
      left: undefined,
      detail: {},
      related: [],
      navList: [
        {
          id: 0,
          pathName: 'home',
          select: true,
          path: '/',
          label: '首页'
        },
        {
          id: 1,
          pathName: 'guoNeiZiXun',
          select: false,
          path: '/#/guoNeiZiXun',
          label: '国内资讯'
        },
        {
          id: 2,
          pathName: 'guoWaiZiXun',
          select: false,
          path: '/#/guoWaiZiXun',
          label: '国外资讯'
        },
        {
          id: 3,
          pathName: 'zuiXinZiXun',
          select: false,
          path: '/#/zuiXinZiXun',
          label: '最新资讯'
        },
        {
          id: 4,
          pathName: 'hangYeZiXun',
          select: false,
          path: '/#/hangYeZiXun',
          label: '行业资讯'
        },
        {
          id: 5,
          pathName: 'shiShiXinWen',
          select: false,
          path: '/#/shiShiXinWen',
          label: '时事新闻'
        }
      ]
    }
  },
  mounted() {
    this._getDetail()
    this._getRelated()
  },
  methods: {
    _domTitle() {
      const routeName = this.detail.post_parent
      for (const i in this.navList) {
        if (this.navList[i].id === routeName) {
          this.domTitle = this.navList[i].label
          break
        }
      }
    },
    _getDetail() {
      http.get('articleDetail', {
        id: this.$route.query.id
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.detail = res.data.data
              this._domTitle()
            }
          })
    },
    _getRelated() {
      http.get('relatedArticle', {
        id: this.$route.query.id
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.related = res.data.data.related
              this.right = res.data.data.right.length > 0 ? res.data.data.right[0] : undefined
              this.left = res.data.data.left.length > 0 ? res.data.data.left[0] : undefined
            }
          })
    }
  }
}
</script>

<style scoped>
.span-title {
  font-weight: bold;
}
</style>